export const MUTATION_GROUP = 'atlassianTeamFields' as const;
